// Recovered compiled webpack factory 97332. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "handleSegmentMismatch", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(35737);
  function a(e, t, r) {
    return (0, n.handleExternalUrl)(e, {}, e.canonicalUrl, !0);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
